var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.menuList),function(item,key){return _c('el-menu',{key:key,attrs:{"default-active":_vm.defaultActive},on:{"select":_vm.selectMenu}},[_c('SubMenu',{attrs:{"menuList":_vm.menuList}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }